var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-info-gradient",style:([_vm.colorObject])},[(_vm.logo)?_c('img',{staticClass:"c-info-mix-background",attrs:{"src":_vm.logo,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }